import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';

/*
  Google pay
*/

export interface GooglePayPaymentMethod {
  [PaymentMethod.GooglePay]: {
    merchantCountry: string;
    allowCardNetworks: GooglePayCreditCardNetworks[];
    allowedAuthMethods: GooglePayAllowedAuthMethods[];
  };
}

export type GooglePayPaymentMethodDTO = GooglePayPaymentMethod;

// google.payments.api.CardParameters['allowedAuthMethods'];
export type GooglePayAllowedAuthMethods = 'PAN_ONLY' | 'CRYPTOGRAM_3DS';

// google.payments.api.CardParameters['allowedCardNetworks'];
export enum GooglePayCreditCardNetworks {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  MasterCard = 'MASTERCARD',
  Visa = 'VISA',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  EloDebit = 'ELO_DEBIT',
  Maestro = 'MAESTRO',
}

/*
  Apple pay
*/

export type MerchantCapabilityDTO = 'SUPPORTS_3DS' | 'SUPPORTS_EMV' | 'SUPPORTS_CREDIT' | 'SUPPORTS_DEBIT';

export interface ApplePayPaymentMethodDTO {
  [PaymentMethod.ApplePay]: {
    merchantCountry: string;
    supportedNetworks: ApplePayCreditCardNetworks[];
    merchantCapabilities: MerchantCapabilityDTO[];
  };
}

export interface ApplePayPaymentMethod {
  [PaymentMethod.ApplePay]: {
    merchantCountry: string;
    supportedNetworks: ApplePayCreditCardNetworks[];
    merchantCapabilities: any; // fix me
  };
}

export enum ApplePayCreditCardNetworks {
  Amex = 'amex',
  CartesBancaires = 'cartesBancaires',
  ChinaUnionPay = 'chinaUnionPay',
  Discover = 'discover',
  Eftpos = 'eftpos',
  Electron = 'electron',
  Elo = 'elo',
  Interac = 'interac',
  Jcb = 'jcb',
  Mada = 'mada',
  Maestro = 'maestro',
  MasterCard = 'masterCard',
  PrivateLabel = 'privateLabel',
  Visa = 'visa',
  VPAY = 'vPay',
}

/*
  PayPal
*/
export interface PayPalPaymentMethod {
  [PaymentMethod.PayPal]: {
    clientId: string;
    merchantId: string;
    creditEnabled: boolean;
    bnCode: string;
  };
}

export type PayPalFundingSource = 'paypal' | 'credit' | 'venmo' | 'paylater';

export type PayPalPaymentMethodDTO = PayPalPaymentMethod;

/*
  ExpressPaymentMethod
*/
type ExpressPaymentMethodDTO = ApplePayPaymentMethodDTO | PayPalPaymentMethodDTO | GooglePayPaymentMethodDTO;
export type ExpressPaymentMethodsDTO = ExpressPaymentMethodDTO[];

export type ExpressPaymentMethod = GooglePayPaymentMethod | ApplePayPaymentMethod | PayPalPaymentMethod;
export type ExpressPaymentMethods = ExpressPaymentMethod[];
export type ExpressPaymentMethodKey = 'googlePay' | 'applePay' | 'payPal';
